import { filterOptions } from '@/utils/query-base'

const city = filterOptions(['EQ', 'EMPTY', 'NEMPTY', 'NE'])
const all = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'BT', 'GT', 'LT', 'LE', 'GE'])

export const pageSearch = {
  'packpl_id': {
    title: '计划单号',
    type: 'input',
    equation: all
  },
  'type': {
    title: '单据类型',
    type: 'select',
    equation: city,
    dictionary: 'A0012'
  },
  'salescenter': {
    title: '营销单元',
    type: 'select',
    equation: city,
    dictionary: 'sale',
    unSearchRole: 'WLY001'
  },
  'partner': {
    title: '客户编码',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ClientSelect',
      title: '客户选择'
    },
    unSearchRole: 'WLY001'
  },
  'name': {
    title: '客户名称',
    type: 'input',
    equation: all,
    unSearchRole: 'WLY001'
  },
  'status': {
    title: '单据状态',
    type: 'select',
    equation: city,
    dictionary: 'A0013'
  },
  'datum': {
    title: '创建日期',
    type: 'date',
    equation: all
  },
  'matnr': {
    title: '产品',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ProductSelect',
      title: '产品选择'
    }
  }
}

export const config1 = {
  'packpl_id': {
    title: '材料计划单',
    slot: true
  },
  'packtype': {
    title: '单据类型',
    width: 180
  },
  'customer': {
    title: '客户编码'
  },
  'name1': {
    title: '名称',
    width: 250
  },
  'customertype': {
    title: '客户类型'
  },
  'status': {
    title: '状态'
  },
  'sal_center': {
    title: '营销单元'
  },
  'datum': {
    title: '创建时间'
  },
  'uname': {
    title: '创建人'
  },
  'remark': {
    title: '备注'
  }
}

export const config2 = {
  'packpl_id': {
    title: '材料计划单',
    slot: true
  },
  'product_id': {
    title: '产品编码',
    width: 180
  },
  'description': {
    title: '产品描述',
    width: 400
  },
  'wlybrand': {
    title: '品牌'
  },
  'planqty_box': {
    title: '计划数量(件)'
  },
  'planqty_bottle': {
    title: '计划数量(瓶)'
  },
  'planqty_ton': {
    title: '计划数量(吨)'
  },
  'status': {
    title: '状态'
  },
  'remark': {
    title: '备注'
  },
  'packsum_id': {
    title: '材料汇总单号'
  }
}



// WEBPACK FOOTER //
// ./src/views/material-plan-manage/config/materialPlanQuery.js